import React from 'react'
import { space } from '@entur/tokens'
import { SmallText, StrongText } from '@entur/typography'
import { Badge } from '@entur/layout'
import { ClosedLockIcon } from '@entur/icons'
import { TicketRight } from '../../../api-clients/api-types'
import { toPrintFormat } from '../../../utils/date-utils'
import { InfoCard } from '../../card/card'
import ArrowICon from './ny-rettighet.svg?react'
import { TicketRightCategoryBadge } from '../ticket-right-category-badge'
import { useClientInfo } from '../../../contexts/client-info-context'

type TicketRightCardProps = {
  activeTicketRight: TicketRight
  draft: TicketRight
}
export const ChangedTicketRightDraft: React.FC<TicketRightCardProps> = ({ activeTicketRight, draft }) => {
  const { hasSensitiveAccess } = useClientInfo()
  const hasChangedRule = activeTicketRight.createdByRule?.id !== draft.createdByRule?.id
  const hasChangedProduct = activeTicketRight.ticketType.code !== draft.ticketType.code
  const hasChangedTime =
    activeTicketRight.validFrom !== draft.validFrom || activeTicketRight.validUntil !== draft.validUntil
  const isEnding = draft.note === 'OPPHØR'
  const hasChanges = hasChangedRule || hasChangedProduct || hasChangedTime || isEnding

  const isNew = activeTicketRight.ticketType.code !== 'NO'

  const changedLozenge = (
    <>
      <Badge style={{ display: 'inline-block' }} variant="success">
        {isNew ? 'ENDRING' : 'NY'}
      </Badge>{' '}
      <TicketRightCategoryBadge ticketRight={draft} />
    </>
  )
  const endedLozenge = (
    <Badge variant="danger" style={{ display: 'inline-block' }}>
      OPPHØR
    </Badge>
  )
  const header = isEnding ? endedLozenge : changedLozenge

  if (hasChanges) {
    return (
      <>
        <div>
          <ArrowICon style={{ float: 'left', marginTop: '26px', marginLeft: '24px' }} />
          <InfoCard
            header={header}
            style={{ float: 'right', width: '90%', paddingTop: space.extraSmall, paddingBottom: space.extraSmall }}
          >
            <SmallText>
              <StrongText>Periode: </StrongText>
              {toPrintFormat(draft.validFrom)} - {toPrintFormat(draft.validUntil)}
              <StrongText style={{ marginLeft: space.small }}>Regel: </StrongText>
              {hasSensitiveAccess ? (
                draft.createdByRule?.name
              ) : (
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                  Ikke tilgang <ClosedLockIcon />
                </span>
              )}
            </SmallText>
          </InfoCard>
        </div>
        <div style={{ clear: 'both', marginBottom: space.extraSmall2 }}> </div>
      </>
    )
  }
  return <></>
}
